import { observer } from "mobx-react";
import { h } from "preact";
import SectionItemButton from "./SectionItemButton";
import SectionItemLabels from "./SectionItemLabels";
import { adjustImage, makeImgUrl } from "../../utils/URL";
import ProductTagsIcons from "../../components/ProductTagsIcons";
import AllergensPopover from "../../components/AllergensPopover";
const MenuGroupSectionItem = (props) => {
    const { menuSectionItem, menuSectionId, menuSectionItemId, openProductCreator, } = props;
    switch (menuSectionItem.content.type) {
        case "SingleProduct":
            return (h(SingleProduct, { item: menuSectionItem.content, sectionId: menuSectionId, sectionItemId: menuSectionItemId, openProductCreator: openProductCreator }));
        case "Creator":
            return (h(Creator, { creator: menuSectionItem.content, sectionId: menuSectionId, sectionItemId: menuSectionItemId, openProductCreator: openProductCreator }));
    }
};
const SingleProduct = (props) => {
    const { item, sectionId, sectionItemId, openProductCreator } = props;
    const hasAllergens = item.productAllergens.length > 0;
    return (h("li", { class: "m-list__item", "data-menu-section-item-id": sectionItemId.value, "data-menu-section-id": sectionId.value },
        h("div", { class: "m-item m-item--list dish" },
            h("div", { class: "m-item__row" },
                item.photoUrn !== null && (h(DishImage, { urn: item.photoUrn, onClick: () => openProductCreator(item.variants[0].instance) })),
                h("div", { class: "m-item__col-header" },
                    h("div", { class: "m-item__header" },
                        h(SectionItemLabels, { tags: item.tags, freeModifierItemsCount: item.freeModifierItemsCount, labelsCreator: item.labelsCreator, availabilitySchedule: item.availabilitySchedule }),
                        h("h4", { class: "m-item__title restaurant-menu__dish-name" },
                            item.name,
                            h(ProductTagsIcons, { tags: item.tags, tooltipPlacement: "bottom" }),
                            hasAllergens && (h(AllergensPopover, { allergens: item.productAllergens })))),
                    h("div", { class: "m-item__description" },
                        h("span", null, item.description),
                        item.description !== "" ? " " : null,
                        h("span", null, item.baseIngredients))),
                h("div", { class: "m-item__col m-item__col--secondary actions menuv2-cart-button", "data-menu-section-item-id": item.id, "data-menu-section-id": sectionId.value, "data-type": "single-product" },
                    h(SectionItemButton, { menuSectionItemContent: item, openProductCreator: openProductCreator, disableDropdown: true }))))));
};
const Creator = (props) => {
    const { creator, sectionId, sectionItemId, openProductCreator } = props;
    return (h("li", { class: "m-list__item", "data-menu-section-item-id": sectionItemId.value, "data-menu-section-id": sectionId.value },
        h("div", { class: "m-item m-item--list pizza" },
            h("div", { class: "m-item__row" },
                creator.photoUrn !== null && (h(DishImage, { urn: creator.photoUrn, onClick: () => openProductCreator(creator.variant.instance) })),
                h("div", { class: "m-item__col-header" },
                    h("div", { class: "m-item__header" },
                        h("h4", { class: "m-item__title restaurant-menu__dish-name" }, creator.name)),
                    h("div", { class: "m-item__description" },
                        h("span", { class: "muted" }, creator.description))),
                h("div", { class: "m-item__col m-item__col--secondary actions menuv2-cart-button", "data-menu-section-item-id": sectionItemId.value, "data-menu-section-id": sectionId.value },
                    h("div", { class: "btn-group" },
                        h(SectionItemButton, { menuSectionItemContent: creator, openProductCreator: openProductCreator, disableDropdown: true })))))));
};
const DishImage = (props) => {
    const { urn, onClick } = props;
    const params = { w: 280, h: 280, crop: true };
    const url = adjustImage(params, makeImgUrl(urn));
    const handleClick = (event) => {
        event.preventDefault();
        if (onClick) {
            onClick();
        }
    };
    return (h("div", { class: "m-item__image-aside m-item__image-aside--thumbnail" },
        h("button", { type: "button", class: "u-btn-unstyled", onClick: handleClick },
            h("img", { src: url, class: "img-responsive u-border-radius", alt: "" }))));
};
export default observer(MenuGroupSectionItem);
